(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ticker-section"] && !Shopify.designMode) return;
  try {
    
class ClientSlider {
  constructor(container) {
    this.container = container;
    this.slider = this.container.querySelector('.client-logos');
    this.slides = this.container.querySelectorAll('.client-logo');
    this.prevBtn = this.container.querySelector('.nav-button.prev');
    this.nextBtn = this.container.querySelector('.nav-button.next');
    this.currentIndex = 0;
    this.slidesPerView = window.innerWidth <= 767 ? 1 : 5;

    this.init();
  }

  init() {
    this.addEventListeners();
    this.updateButtonVisibility();
  }

  addEventListeners() {
    this.prevBtn.addEventListener('click', () => this.slide('prev'));
    this.nextBtn.addEventListener('click', () => this.slide('next'));
    window.addEventListener('resize', () => {
      this.slidesPerView = window.innerWidth <= 767 ? 1 : 5;
      this.slide('reset');
    });
  }

  slide(direction) {
    if (direction === 'prev' && this.currentIndex > 0) {
      this.currentIndex--;
    } else if (direction === 'next' && this.currentIndex < this.slides.length - this.slidesPerView) {
      this.currentIndex++;
    } else if (direction === 'reset') {
      this.currentIndex = 0;
    }
    
    const translateValue = -(this.currentIndex * (100 / this.slidesPerView));
    this.slider.style.transform = `translateX(${translateValue}%)`;
    this.updateButtonVisibility();
  }

  updateButtonVisibility() {
    this.prevBtn.style.opacity = this.currentIndex === 0 ? '0.5' : '1';
    this.nextBtn.style.opacity = this.currentIndex >= this.slides.length - this.slidesPerView ? '0.5' : '1';
  }
}

function initClientSlider(container) {
  new ClientSlider(container);
}

document.addEventListener('DOMContentLoaded', () => {
  const clientSections = document.querySelectorAll('.our-clients');
  clientSections.forEach(initClientSlider);
});

document.addEventListener('shopify:section:load', (event) => {
  if (event.target.classList.contains('our-clients')) {
    initClientSlider(event.target);
  }
});

  } catch(e) { console.error(e); }
})();
})();
